export const permissionArray = [
    {
      module: 'studyMaterial',
      access: ['view']
    },
    {
      module: 'question',
      access: ['none'],
    },
    {
      module: 'test',
      access: ['none'],
    },
    {
      module: 'rule',
      access: ['view']
    },
    {
      module: 'tag',
      access: ['view', 'createOptional']
    },
    {
      module: 'goal',
      access: ['none']
    },
    {
      module: 'edp',
      access: ['none']
    },
    {
      module: 'user',
      access: ['none']
    },
    {
      module: 'course',
      access: ['none']
    },
    {
      module: 'share',
      access: ['allow']
    },
    {
      module: 'ftreQuestion',
      access: ['none']
    },
    {
      module: 'aitsQuestion',
      access: ['none']
    },
    {
      module: 'nationalLevelQuestion',
      access: ['none']
    },
    {
      module: 'ftreTest',
      access: ['none']
    },
    {
      module: 'aitsTest',
      access: ['none']
    },
    {
      module: 'nationalLevelTest',
      access: ['none']
    },
    {
      module: 'defaultTemplate',
      access: ['none']
    },
    {
      module: 'customTemplate',
      access: ['none']
    },
    {
      module: 'edp_report_ques_create',
      access: ['none']
    },
    {
      module: 'edp_report_ques_issue',
      access: ['none']
    },
  ]